import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AgentService } from '../services/agent.service';
import { AgentPartyEducationHandlerComponent } from './agent-party-education.handler';

@Component({
  selector: 'sym-agent-party-education',
  templateUrl: './agent-party-education.component.html',
  styleUrls: ['./agent-party-education.component.scss'],
})
export class AgentPartyEducationComponent extends AgentPartyEducationHandlerComponent {
  @Input() public partyModel: any;

  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['partyModel'] && changes['partyModel'].currentValue) {
      this.partyModel = this.partyModel;
    }
  }
}
